import PrimaryButton from "../designSystem/buttons/PrimaryButton";
import SecondaryButton from "../designSystem/buttons/SecondaryButton";
import SeeMoreButton from "../designSystem/buttons/SeeMoreButton";
import Hero from "../designSystem/Hero";
import HeroBackground from "../../assets/images/Home1.jpg";
import AboutImage from "../../assets/images/Calculators2.jpg";
import ContactUsPage from "./ContactUsPage";
import { useNavigate } from "react-router-dom";
import "../../css/pages/homePage.css";

import { ReactComponent as InvestmentsIcon } from "../../assets/icons/RelevantLifeTax.svg";
import { ReactComponent as PensionsIcon } from "../../assets/icons/PensionShortfall.svg";
import { ReactComponent as ProtectionIcon } from "../../assets/icons/InheritanceTax.svg";
import { ReactComponent as EquityReleaseIcon } from "../../assets/icons/InvestmentCalculator.svg";
import TertiaryButton from "../designSystem/buttons/TertiaryButton";
import HeroImage from "../../assets/images/Calculators1.jpg";

const CalculatorPage = () => {
  const navigate = useNavigate();

  const services = [
    {
      title: "Relevant Life Tax",
      icon: <InvestmentsIcon />,
      path: "/relevant-life-tax",
    },
    {
      title: "Pension Shortfall",
      icon: <PensionsIcon />,
      path: "/pension-shortfall",
    },
    {
      title: "Inheritance Tax",
      icon: <ProtectionIcon />,
      path: "/inheritance-tax",
    },
    {
      title: "Investment",
      icon: <EquityReleaseIcon />,
      path: "/investment-calculator",
    },
  ];

  return (
    <div className="home-page">
      <Hero
        title="Calculators"
        // subtitle="Equity release"
        primary={true}
        backgroundImage={HeroImage}
        titleAlign="center"
        subtitleAlign="center"
      />

      <section className="home-about-section">
        <div className="home-container about-grid">
          <div className="about-content">
            <div className="nav primary">CALCULATORS</div>

            <h2 className="secondary">
              OUR <span className="italic-text">CALCULATORS</span>
            </h2>

            <div className="small-divider" />

            {/* <div className="content-semibold primary">
              We provide clear, independent financial advice designed to help
              you make confident decisions about your future.
            </div> */}

            <div className="content primary">
              Explore our range of easy-to-use calculators designed to help you
              plan and better understand your finances. Whether you’re looking
              to estimate your tax position, identify potential pension gaps,
              plan for inheritance tax, or explore investment outcomes, simply
              enter your details and adjust the options to see how different
              factors could affect your results.
            </div>

            {/* <TertiaryButton
              text="Find Out More"
              onClick={() => navigate("/about-us")}
            /> */}
          </div>

          <div className="about-image-wrap">
            <img src={AboutImage} alt="Family walking outdoors" />
          </div>
        </div>
      </section>

      <section className="services-section">
        <div className="home-container">
          {/* <div className="services-heading">
            <div className="nav ">Services</div>

            <h2>
              How <span className="italic-text">We Can Help</span>
            </h2>

            <div className="services-divider" />
          </div> */}

          <div className="services-grid">
            {services.map((service) => (
              <div
                className="service-card"
                key={service.title}
                    onClick={() => navigate(service.path)}
                    style={{ cursor: "pointer" }}
              >
                <div className="service-icon">{service.icon}</div>

                <h3 className="italic-text">{service.title}</h3>

                {/* <SecondaryButton
                  text="Find Out More"
                  onClick={() => navigate(service.path)}
                /> */}
              </div>
            ))}
          </div>
        </div>
      </section>
      <ContactUsPage/>
    </div>
  );
};

export default CalculatorPage;
